module.exports = __webpack_public_path__ + "static/media/face-male-3.797cf7e2.jpg";